module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: _vm.$style.root
  }, [_c('div', {
    staticClass: "campaign-post",
    class: {
      "campaign-post--active": _vm.active
    }
  }, [_c('div', {
    staticClass: "campaign-post-head"
  }, [_c('div', {
    staticClass: "campaign-post-last-save"
  }, [_vm._v(_vm._s(_vm.$t('pos.campaign.creatives.last-save')))]), _c('div', {
    staticClass: "campaign-post-date"
  }, [_vm._v(_vm._s(_vm.createdAt))]), _c('div', {
    staticClass: "campaign-post-id"
  }, [_vm._v("ID " + _vm._s(_vm.creative.id))]), _c('div', {
    staticClass: "clearfix"
  })]), _c('div', {
    staticClass: "campaign-post-content"
  }, [_c('creative-preview', {
    staticClass: "creative-container",
    attrs: {
      "creative": _vm.creative,
      "facebookPage": _vm.creative.campaign.fbpage,
      "landingPage": _vm.landingPage,
      "placeholders": "placeholders",
      "enableFormPreview": true
    }
  })], 1), _c('div', {
    staticClass: "row no-gutters mt-3 campaign-post-buttons"
  }, [_c('div', {
    staticClass: "col-sm-12",
    staticStyle: {
      "padding-left": "3px"
    }
  }, [_c('gotu-nav-button', {
    staticClass: "editCreativeBtn",
    attrs: {
      "iconLeft": "pencil",
      "iconSize": 0.8
    },
    on: {
      "click": _vm.edit
    }
  }, [_vm._v(_vm._s(_vm.$t('pos.campaign.creatives.buttons.edit')))]), (_vm.isApproved) ? _c('div', {
    staticClass: "activation-buttons"
  }, [(!_vm.creative.active && _vm.permissions.includes("activate")) ? _c('gotu-nav-button', {
    attrs: {
      "theme": "default-cta",
      "disabled": _vm.activatingCreative,
      "loading": _vm.activatingCreative
    },
    on: {
      "click": _vm.activateCreative
    }
  }, [_vm._v(_vm._s(_vm.$t('pos.creative.set-as-active')))]) : _vm._e(), (_vm.creative.active) ? _c('div', {
    staticClass: "disabled"
  }, [_vm._v(_vm._s(_vm.$t('pos.creative.active')))]) : _vm._e()], 1) : _vm._e()], 1)])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0e7fac9d"}!./~/vue-loader/lib/template-compiler/preprocessor.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/campaign-creatives/creative/Creative.vue
// module id = 2003
// module chunks = 1